export const TopIssueWangZheExpNameType = Object.freeze({
  // 全部
  ALL: 0,
  // 局内
  IN_BATTLE: 1,
  // 局外
  OUT_BATTLE: 2,
});
